import React from 'react';
import Box from '@tds/core-box';
import HairlineDivider from '@tds/core-hairline-divider';
import Paragraph from '@tds/core-paragraph';

import { ContentWrapper } from '../design/css';
import EN from '../../EN.json';
import FR from '../../FR.json';

const Success = () => {
  const {
    contractSignature: { successPage: successEn }
  } = EN;
  const {
    contractSignature: { successPage: successFr }
  } = FR;

  return (
    <>
      <Box between={4}>
        <HairlineDivider />
        <HairlineDivider />
      </Box>
      <div className="container 85%">
        <ContentWrapper style={{ minHeight: 'auto' }}>
          <Paragraph>{successEn}</Paragraph>
          <Box>
            <br />
          </Box>
          <Paragraph>{successFr}</Paragraph>
        </ContentWrapper>
      </div>
    </>
  );
};

export default Success;
